export default function useShouldAnimate() {
    return () => false;
}
